import { client } from 'config/graphql/client';
import { DEMO_MODE_INFO_MESSAGE } from 'config/graphql/errors';
import { SEND_SMS } from 'config/graphql/queries';
import { SEND_STAFF_SMS } from 'config/graphql/staffQueries';
import { CloudError } from 'repository/CloudError';
import { type CloudResult } from 'repository/repository';
import { type Sms } from 'typedefs/sms';
import { isStandalone } from 'utils/environment';

export interface SmsRepository {
  sendSMS(message: string, personCSIds: string[], tournamentId: string): Promise<CloudResult<Sms>>;
  sendStaffSMS(message: string, staffId: string, tournamentId: string): Promise<CloudResult<Sms>>;
}

export class SmsRepositoryImpl implements SmsRepository {
  async sendSMS(message: string, personIds: string[], tournamentId: string): Promise<CloudResult<Sms>> {
    if (isStandalone()) {
      return Promise.resolve({ error: new CloudError('demo-mode-query', DEMO_MODE_INFO_MESSAGE) });
    }
    const smsSent = await client.mutate({
      mutation: SEND_SMS,
      variables: { message, personIds, tournamentId },
    });
    if (smsSent?.data) {
      return Promise.resolve({ data: smsSent?.data });
    }
    return Promise.resolve({ error: new CloudError(smsSent?.errors[0].name, smsSent?.errors[0].message) });
  }

  async sendStaffSMS(message: string, staffId: string, tournamentId: string): Promise<CloudResult<Sms>> {
    if (isStandalone()) {
      return Promise.resolve({ error: new CloudError('demo-mode-query', DEMO_MODE_INFO_MESSAGE) });
    }
    const smsSent = await client.mutate({
      mutation: SEND_STAFF_SMS,
      variables: { message, staffId, tournamentId },
    });
    if (smsSent?.data) {
      return Promise.resolve({ data: smsSent?.data });
    }
    return Promise.resolve({ error: new CloudError(smsSent?.errors[0].name, smsSent?.errors[0].message) });
  }
}
